import {
    Box,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    InputAdornment,
    MenuItem,
    Select,
    styled,
    TextField,
    Typography
} from '@mui/material';
import { ReactComponent as ArrowHorizontal } from 'assets/img/ArrowHorizontal.svg';
import { BreadcrumbsCC, ContainerPage } from 'components/Layout';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import theme, { color } from 'theme';
import './index.css';
// import MeetingMode from "./MeetingMode";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Checkbox from '@mui/material/Checkbox';
import apiManagerRoom from 'api/manager-meeting';
import apiManagerUser from 'api/manager-users';
import { IconClose } from 'assets/icons';
import { TooltipCC } from 'components/common';
import { ButtonCancelIcon, ButtonSaveIcon, ButtonUploadFile } from 'components/common/Button';
import DateRangePickerCC from 'components/common/DateRangePickerCC';
import useHandleDateRangePicker from 'components/common/DateRangePickerCC/useHandleDateRangePicker';
import { DIALOG_ID } from 'components/Dialog/constant';
import { DialogShareToParticipants, useDialog } from 'components/DialogV3';
import IconCancel from 'components/IconComponent/IconCancel';
import IconSave from 'components/IconComponent/IconSave';
import ReloadIcon from 'components/IconComponent/ReloadIcon';
import { PATH_ROOT } from 'constants/api';
import { FUNCTIONS } from 'constants/roles';
import { DEFAULT_TIMESEARCH } from 'constants/search';
import { TOAST_DEFAULT } from 'constants/toast';
import { decode } from 'js-base64';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import useHandleModal from 'pages/manager-meeting/hook/useHandleModal';
import ModelPeriodDay from 'pages/manager-meeting/model/modelPeriodDay';
import {
    setClearValue,
    setCurrentTime,
    setEndTime,
    setEndTimeSecond,
    setIsChangePeriod,
    setStartTime,
    setStartTimeSecond,
    setTimeRoom,
    setValue,
} from 'pages/manager-meeting/modelPeriodSlice';
import { ROLE } from 'pages/subtitles/components/constants';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { checkFunctionHaveCode } from 'store/user/functions';
import { selectCurrentUserFunctions } from 'store/selectors';
import { toApiPeriodDate } from 'store/periodState';
import { getAccessToken } from 'utils/cookies';
import { createRandomPassword } from 'utils/functions';
import { CustomSortArray } from 'utils/functions/participant';
import {
    removeLoadingButtonDialogConfirm,
    setCloseDialogCC,
    setOpenDialogCC,
    toastError,
    toastInfo,
    toastSuccess,
    toastWarning,
} from 'utils/helpers';
import { maxDateTime, MEETING_MODE } from '../constants';
import { convertHourAndMinToSecond, convertSecondToHourAndMinute, convertUnixTimestampToSeconds, CreateDescPeriod, minuteToHourAndMinute, roundTimeEndDay, roundTimeStartDay, secondsToHoursMinutes, secondsToMinutes } from '../functions';
import useHandleDataSchedule from '../hook/useHandleDataSchedule';
import useHandleFile from '../hook/useHandleFile';
import { handleValidateInput } from '../hook/useHandleValidateInput';
import { AdvancedSettings } from './AdvancedSetting';
import DialogWarningLicenseRoom from './DialogWarningLicenseRoom';
import { InfoMeetingCC } from './InfoMeetingCC';
import ItemFile from './ItemFile';
import ListParticipantsShareRoom from './ListParticipantsShareRoom';
import MeetingMode from './MeetingMode';
import { TimePickerCC } from './TimePickerCC';
import { useResponsivePixel } from './useResponsivePixel';

const CssTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        paddingRight: '0px',
        '& input': {
            paddingTop: '6.5px',
            paddingBottom: '6.5px',
        },
    },
    '& .MuiFormHelperText-root': {
        position: 'absolute',
        top: '35px'
    }
});

export const InfoOutlinedIconCC = styled(InfoOutlinedIcon)({
    fontSize: 18,
    color: color.grey01,
});
const ScheduleMeeting = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const functions = useSelector(selectCurrentUserFunctions);
    const {
        open: openConfirm,
        handleOpenModal,
        handleCloseModal,
        periodTime,
        setPeriodTime,
        typePeriod,
        setTypePeriod,
    } = useHandleModal();
    const { timePicker: startTimePicker, setTimePicker: setStartTimePicker } = useHandleDateRangePicker({
        startDate: roundTimeStartDay(),
        endDate: DEFAULT_TIMESEARCH.endDate,
    });
    const { timePicker: endTimePicker, setTimePicker: setEndTimePicker } = useHandleDateRangePicker({
        startDate: roundTimeEndDay(),
        endDate: DEFAULT_TIMESEARCH.endDate,
    });
    const {
        files,
        setFiles,
        handleUploadFile,
        onDeleteFile,
        filesUpload,
        setFilesUpload,
        filesRoomGetted,
        setFilesRoomGetted,
        hasAttachFiles,
        slot,
        setRoomId,
        isUpdating
    } = useHandleFile();
    const {
        data,
        setData,
        userListId,
        setUserListId,
        checkDurationMax,
        setCheckDurationMax,
        checkDurationMin,
        setCheckDurationMin,
        isPassword,
        setisPassword,
        isCreate,
        setIsCreate,
        count,
        setCount,
        setOpenModalConfirmPassword,
        isPeriod,
        setIsPeriod,
        isLobby,
        setIsLobby,
        setLoading,
    } = useHandleDataSchedule();

    const { openDialog } = useDialog()
    const [errorValid, setErrorValid] = useState(() => handleValidateInput(data, t));
    const [clickSubmit, setClickSubmit] = useState(false);
    const [changeData, setChangeData] = useState(false);
    const [checkChangeTime, setCheckChangeTime] = useState(false);
    const [checkValidStartTimeSecond, setCheckValidStartTimeSecond] = useState(true);
    const [checkValidEndTimeSecond, setCheckValidEndTimeSecond] = useState(true);
    const [isFetchedData, setIsFetchedData] = useState(true);
    const { pathname } = useLocation();
    const isUpdate = pathname.includes('update');
    const [checkChangeParticipant, setCheckChangeParticipant] = useState(false);
    const dataPeriod = useSelector((state) => state.modelPeriod);
    const [location] = useSearchParams();
    const isCopy = pathname.includes('copy');
    const navigate = useNavigate();
    const { mdPixel } = useResponsivePixel();
    const [isSubmit, setIsSubmit] = useState(false);
    const timeMinute = Math.floor(parseInt(checkFunctionHaveCode(functions, FUNCTIONS.MEETING_DURATION_LIMIT)) / 60) < 15 ? 15 : Math.floor(parseInt(checkFunctionHaveCode(functions, FUNCTIONS.MEETING_DURATION_LIMIT)) / 60);
    const maxNumberInvitePeople = parseInt(checkFunctionHaveCode(functions, FUNCTIONS.MEETING_PARTICIPANTS_LIMIT));
    const maxNumberPeople = parseInt(checkFunctionHaveCode(functions, FUNCTIONS.MEETING_PARTICIPANTS_LIMIT));

    const fetchUsers = (data, correctUserName = false) => {
        if (correctUserName) {
            return apiManagerRoom.searchUserForRoom({ query: data, correctUserName: true });
        } else return apiManagerRoom.searchUserForRoom({ query: data });
    };

    const getUsernameFromAccessToken = () => {
        try {
            const accessToken = getAccessToken();
            return accessToken ? JSON.parse(decode(accessToken.split('.')[1]))?.context?.user?.username : undefined;
        } catch (error) {
            return undefined;
        }
    };

    const getCurrentUserForSchedule = async () => {
        let currentUser;

        try {
            const userByToken = await apiManagerUser.getUserByToken();
            currentUser = userByToken?.data?.[0];
        } catch (error) {
            currentUser = undefined;
        }

        const currentUsername = currentUser?.username || getUsernameFromAccessToken();

        if (!currentUsername) {
            return currentUser;
        }

        try {
            const userSearch = await fetchUsers(currentUsername, true);
            return userSearch?.data?.find((user) => user?.username === currentUsername) || userSearch?.data?.[0] || currentUser;
        } catch (error) {
            return currentUser;
        }
    };

    const handleOpenModalPeriod = (type_id) => {
        setTypePeriod(type_id);
        if (!dataPeriod.time_profile_type_id) {
            setPeriodTime({
                start: dataPeriod.start,
                end: moment(dataPeriod.start).add(
                    type_id === 1 ? 7 : type_id === 2 ? 4 : 2,
                    type_id === 1 ? 'days' : type_id === 2 ? 'w' : 'M',
                ),
            });
        } else if (dataPeriod.time_profile_type_id !== type_id) {
            setPeriodTime({
                start: dataPeriod.start,
                end: moment(dataPeriod.start).add(
                    type_id === 1 ? 7 : type_id === 2 ? 4 : 2,
                    type_id === 1 ? 'days' : type_id === 2 ? 'w' : 'M',
                ),
            });
        } else if (dataPeriod.time_profile_type_id === type_id) {
            setPeriodTime({
                start: dataPeriod.start_time,
                end: dataPeriod.end_time,
            });
        }
        handleOpenModal();
    };

    const handleChangeDataShareOperators = (user) => {
        if (!user?.isDeleted) {
            const findHostUser = data.operatorList?.find((user) => user.role === ROLE.HOST);
            if (findHostUser && user.role === ROLE.HOST) {
                toastInfo(t('validate.only-one-host'));
            } else {
                const newOperatorList = data.operatorList.filter((oper) => oper?.id !== user?.id);
                setData({
                    ...data,
                    operatorList: CustomSortArray([...newOperatorList, user]),
                });
            }
        } else {
            setData({
                ...data,
                operatorList: data.operatorList.filter((oper) => oper.id !== user.id),
            });
        }
    };

    const handleChangeDataShareParticipant = (user) => {
        if (!user?.isDeleted) {
            const newParticipantList = data.participantList.filter((oper) => oper?.username !== user?.username);

            setData({
                ...data,
                participantList: [...newParticipantList, user],
            });
        } else {
            setData({
                ...data,
                participantList: data.participantList.filter((oper) => oper.username !== user.username),
            });
        }
    };

    const handleShareSubsForOperator = (live_captions_id, idsUser, userListRender) => {
        setData({
            ...data,
            operatorList: [
                ...data.operatorList.filter((user) => user.role === ROLE.OWNER),
                ...userListRender.filter((user) => user.role !== ROLE.OWNER).map((user) => ({
                    ...user,
                    role: user.role !== ROLE.HOST && user.role !== ROLE.CO_HOST ? ROLE.CO_HOST : user.role,
                })),
            ],
        });
        if (!checkChangeParticipant) {
            setCheckChangeParticipant(true);
        }
    };

    const handleShareSubs = (live_captions_id, idsUser, userListRender) => {
        setData({
            ...data,
            participantList: userListRender.map((user) => ({ ...user, role: ROLE.PARTICIPANT })),
        });
        if (!checkChangeParticipant) {
            setCheckChangeParticipant(true);
        }
    };

    const handleActionConfirmPass = () => {
        setisPassword(true);
        setCount(1);
        setData((prevData) => ({
            ...prevData,
            password: createRandomPassword(),
        }));
    };

    const handleOpenModalShareSubtitlesForOperator = () => {
        openDialog(DialogShareToParticipants, {
            userIdList: userListId,
            useListParticipantsShareRoom: true,
            selectRole: true,
            live_captions_id: '',
            onSubmit: handleShareSubsForOperator,
            userList: data.operatorList,
            roleParticipant: ROLE.CO_HOST,
            titleKey: 'meeting.popup.title-invite-operator',
            titleListParticipant: 'meeting.popup.list-operator',
            maxTotalPeople: maxNumberInvitePeople,
            currentTotalPeople: parseInt(data.participantList.length)
        })
    };

    const handleOpenModalShareSubtitles = () => {
        openDialog(DialogShareToParticipants, {
            userIdList: userListId,
            useListParticipantsShareRoom: true,
            live_captions_id: '',
            onSubmit: handleShareSubs,
            userList: data.participantList,
            titleKey: 'meeting.popup.title-invite-par',
            titleListParticipant: 'meeting.popup.list-participant',
            maxTotalPeople: maxNumberInvitePeople,
            currentTotalPeople: parseInt(data.operatorList.length)
        })
    };

    const aleartCreatedRoom = () => {
        toastSuccess(t('meeting.scheduleSuccess'));
        navigate(`${PATH_ROOT}/manager-meeting`);
        setLoading(false);
        setIsSubmit(false)
        setFilesUpload([]);
    };

    const aleartUpdatedRoom = () => {
        toastSuccess(t('meeting.updateSuccess'));
        navigate(`${PATH_ROOT}/manager-meeting`);
        setIsSubmit(false)
    }

    const createRoom = (data) => {
        return apiManagerRoom.createRoom(data);
    };

    const getRoom = (data) => {
        return apiManagerRoom.getRoom(data);
    };

    const getFiles = (roomId) => {
        return apiManagerRoom.getFiles(roomId);
    };

    const updateRoom = (data) => {
        return apiManagerRoom.updateRoom(data);
    };

    const handleCreateRoom = () => {
        setClickSubmit(true);

        if (errorValid['roomName'].value) {
            return;
        }
        if (errorValid['description'].value) {
            return;
        }
        if (isPassword && errorValid['password'].value) {
            return;
        }
        if (isPeriod && dataPeriod.time_profile_type_id === null) {
            return;
        }
        if (secondsToMinutes(parseInt(moment(dataPeriod.end).unix()) - parseInt(moment(dataPeriod.start).unix())) > timeMinute) {
            setCheckDurationMax(false);
            return;
        }

        if (data?.operatorList?.length + data.participantList?.length > maxNumberInvitePeople) {
            toastWarning(t('validate.over-max-people'))
            return;
        }

        switch (data.meetingMode) {
            case MEETING_MODE.NORMAL:
                if (!checkDurationMax || !checkDurationMin || !checkValidStartTimeSecond || !checkValidEndTimeSecond) {
                    return;
                }
                if (!isPassword && isCreate && count === 0) {
                    setOpenDialogCC({
                        id: DIALOG_ID.CONFIRM,
                        props: {
                            title: t('room.pop-up.password.title'),
                            contentText: t('room.pop-up.password.content'),
                            isDisableLoadingButton: true,
                            onClick: () => {
                                handleActionConfirmPass();
                                setCloseDialogCC();
                            },
                            onCancel: () => {
                                handleSubmitValue();
                            },
                        },
                    });
                } else {
                    handleSubmitValue();
                }
                break;
            case MEETING_MODE.PRIVATE:
                if (!checkDurationMax || !checkDurationMin || !checkValidStartTimeSecond || !checkValidEndTimeSecond) {
                    return;
                }
                if (userListId.length <= 1) {
                    toastInfo(t('validate.private-room-part'));
                } else {
                    handleSubmitValue();
                }
                break;
            default:
        }
    };

    const handleSubmitValue = async () => {
        const canEdit = checkFunctionHaveCode(functions, FUNCTIONS.MANAGE_MEETING_SCHEDULE_EDIT)
        if (!canEdit) return setOpenDialogCC({
            id: DIALOG_ID.LIMIT_CREATE,
            props: {
                title: t('dialog.wantCreateNewMeeting'),
                content: t('dialog.limitedCreateMeetingIntro')
            }
        })
        setIsSubmit(true);

        if (!isPassword) {
            data.password = null;
        }
        if (!isPeriod) {
            data.isPeriod = null;
            dispatch(setClearValue());
        } else {
            data.isPeriod = 'yes';
            data.period = {
                time_profile_type_id: dataPeriod.time_profile_type_id,
                start_time: toApiPeriodDate(dataPeriod.start_time),
                end_time: toApiPeriodDate(dataPeriod.end_time),
                interval: dataPeriod.interval,
                day: dataPeriod.day,
                week: dataPeriod.week,
            };
        }
        if (isLobby) {
            data.lobby = 1;
        } else data.lobby = 0;

        let trimmedRoomName = data.roomName.trim();
        if (data.roomName.length > 0 && data.roomName.replace(/\s/g, '').length === 0) {
            toastWarning(t('meeting.roomNameAllWhiteSpace'));
            setOpenModalConfirmPassword(false);
            return;
        }

        data.roomName = trimmedRoomName;
        data.start = moment(dataPeriod.start);
        data.end = moment(dataPeriod.end);
        data.advancedSettings = {
            camera: data.camera,
            micro: data.micro,
            message: data.message,
            sharingFile: data.sharingFile,
            pollPermission: data.pollPermission,
            meetingMode: data.meetingMode,
            sharingScreenPermission: data.sharingScreenPermission,
            whiteboardPermission: data.whiteboardPermission,
            handUpPermission: data.handUpPermission,
            changeNamePermission: data.changeNamePermission,
            recordPermission: data.recordPermission,
            noticeTimeEndRoom: data.noticeTimeEndRoom
        };
        data.participant = [...data.operatorList, ...data.participantList];

        if (isCopy) {
            data.isCopy = true;
        }

        if (isCreate || isCopy) {
            if (Object.keys(filesUpload)) {
                data.slot = slot
            }

            createRoom(data)
                .then(async (r) => {
                    if (r.status === 200) {
                        aleartCreatedRoom();
                    }
                })
                .catch((error) => {
                    setIsSubmit(false);
                    if (error.response.data.detail === 'DURATION_TOO_LATE') {
                        toastError(t('meeting.timeStart'));
                    } else if (error.response.data.detail === 'DURATION_TOO_LONG') {
                        toastError(t('meeting.only24h'));
                    } else if (error.response.data.detail === 'DURATION_TOO_SHORT') {
                        toastError(t('meeting.min15m'));
                    } else if (error.response.data.detail === 'NOT_OWNER') {
                        toastError(t('meeting.notOwner'));
                        navigate(`${PATH_ROOT}/manager-meeting`);
                    } else {
                        toastError(t(TOAST_DEFAULT.ERROR));
                    }
                })
        } else {
            if (hasAttachFiles) {
                let arrayFileId = files.map(file => file?.id).filter(id => id);
                let deleteFile = filesRoomGetted.filter(file => !arrayFileId.includes(file.id)).map(file => ({ name: file.name, id: file?.id }));
                let uploadFile = files.filter(file => !file?.id).map(file => ({ name: file.name, id: file?.id }));

                data.attach_files = [...deleteFile, ...uploadFile]
            }

            updateRoom(data)
                .then(async (r) => {
                    if (r.status === 200) {
                        aleartUpdatedRoom()
                    }
                })
                .catch((error) => {
                    setIsSubmit(false);
                    if (error.response.data.detail === 'DURATION_TOO_LATE') {
                        toastError(t('meeting.timeStart'));
                    } else if (error.response.data.detail === 'DURATION_TOO_LONG') {
                        toastError(t('meeting.only24h'));
                    } else if (error.response.data.detail === 'DURATION_TOO_SHORT') {
                        toastError(t('meeting.min15m'));
                    } else if (error.response.data.detail === 'NOT_OWNER') {
                        toastError(t('meeting.notOwner'));
                        setTimeout(() => {
                            navigate(`${PATH_ROOT}/manager-meeting`);
                        }, [3000]);
                    } else toastError(t(TOAST_DEFAULT.ERROR));
                })
        }
    };

    const handleCancelRoom = () => {
        if (changeData || hasAttachFiles || checkChangeTime || checkChangeParticipant) {
            setOpenDialogCC({
                id: DIALOG_ID.CONFIRM,
                props: {
                    title: t('room.pop-up.confirm.title'),
                    contentText: t('room.pop-up.confirm.content'),
                    isDisableLoadingButton: true,
                    onClick: () => {
                        removeLoadingButtonDialogConfirm();
                        setCloseDialogCC();
                        navigate(`${PATH_ROOT}/manager-meeting`);
                    },
                    onCancel: () => { },
                },
            });
        } else navigate(`${PATH_ROOT}/manager-meeting`);
    };

    useEffect(() => {
        setErrorValid((prev) => handleValidateInput(data, t));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    useEffect(() => {
        if (pathname.includes('update') || pathname.includes('copy')) {
            setIsCreate(false);
            if (location.get('roomId') == null) {
                navigate(`${PATH_ROOT}/manager-meeting`);
            } else {
                getRoom(location.get('roomId'))
                    .then((r) => {
                        if (r.status === 200) {
                            getFiles(location.get('roomId'))
                                .then((res) => {
                                    //set file when copy room
                                    if (isCopy) {
                                        setFiles([]);
                                        setFilesRoomGetted([]);
                                    } else {
                                        setFiles(res.data);
                                        setFilesRoomGetted(cloneDeep(res.data));
                                    }
                                })
                                .catch((err) => err);

                            setData({
                                ...data,
                                id: r.data[0].id,
                                roomId: r.data[0].roomId,
                                roomName: r.data[0].roomName,
                                parentRoomId: r.data[0].parentRoomId,
                                type: r.data[0].type,
                                updatedAt: r.data[0].updatedAt,
                                start: parseInt(r.data[0].tsStart * 1000),
                                end: parseInt(r.data[0].tsEnd * 1000),
                                password: r.data[0].password,
                                lobby: r.data[0].lobby,
                                description: r.data[0].description,
                                isTrash: r.data[0].isTrash,
                                isModify: r.data[0].isModify,
                                isPeriod: r.data[0].isPeriod,
                                period: {
                                    ...r.data[0]?.period,
                                    start_time: parseInt(r.data[0]?.period?.start_time * 1000),
                                    end_time: parseInt(r.data[0]?.period?.end_time * 1000),
                                },
                                userHostId: r.data[0].userHostId,
                                advancedSettings: {
                                    camera: r.data[0].camera_permission,
                                    micro: r.data[0].micro_permission,
                                    message: r.data[0].message_permission_group,
                                    sharingFile: r.data[0].sharing_file_permission,
                                    pollPermission: r.data[0].poll_permission,
                                    meetingMode: r.data[0].meeting_mode,
                                    sharingScreenPermission: r.data[0].sharing_screen_permission,
                                    whiteboardPermission: r.data[0].white_board_permission,
                                    handUpPermission: r.data[0].hand_up_permission,
                                    changeNamePermission: r.data[0].change_name_permission,
                                    recordPermission: r.data[0].record_permission,
                                    noticeTimeEndRoom: parseInt(r.data[0]?.notice_time_end_room)
                                },
                                participantList: r.data[0].participant.filter(
                                    (user) =>
                                        user.role !== ROLE.OWNER &&
                                        user.role !== ROLE.CO_HOST &&
                                        user.role !== ROLE.HOST,
                                ),
                                operatorList: r.data[0].participant.filter((user) => user.role !== ROLE.PARTICIPANT),
                                camera: r.data[0].camera_permission,
                                micro: r.data[0].micro_permission,
                                message: r.data[0].message_permission_group,
                                sharingFile: r.data[0].sharing_file_permission,
                                pollPermission: r.data[0].poll_permission,
                                meetingMode: r.data[0].meeting_mode,
                                sharingScreenPermission: r.data[0].sharing_screen_permission,
                                whiteboardPermission: r.data[0].white_board_permission,
                                handUpPermission: r.data[0].hand_up_permission,
                                changeNamePermission: r.data[0].change_name_permission,
                                recordPermission: r.data[0].record_permission,
                                noticeTimeEndRoom: parseInt(r.data[0]?.notice_time_end_room)
                            });
                            setRoomId(r.data[0].parentRoomId || r.data[0].roomId)
                            //set description, type and isTrash when copy meeting
                            isCopy &&
                                setData((prevData) => ({
                                    ...prevData,
                                    description: '',
                                    type: 'not_start',
                                    isTrash: 0,
                                    password: r.data[0].password ? createRandomPassword() : null,
                                    roomName: `${prevData?.roomName} (${t('actions.copyRoom')})`,
                                }));

                            setUserListId(r.data[0].participant.map((participant) => participant.id));

                            if (r.data[0].password != null) {
                                setisPassword(true);
                            } else {
                                setisPassword(false);
                                setData((prevData) => ({ ...prevData, password: createRandomPassword() }));
                            }
                            if (r.data[0].isPeriod === null) {
                                setIsPeriod(false);
                                dispatch(setClearValue());
                            } else {
                                setIsPeriod(true);
                                dispatch(
                                    setValue({
                                        ...r.data[0].period,
                                        start_time: parseInt(r.data[0]?.period?.start_time * 1000),
                                        end_time: parseInt(r.data[0]?.period?.end_time * 1000),
                                    }),
                                );
                            }
                            //set period time when copy meeting
                            if (isCopy) {
                                setIsPeriod(false);
                                dispatch(setClearValue());
                            }
                            if (r.data[0].lobby === 1) {
                                setIsLobby(true);
                            } else setIsLobby(false);
                            dispatch(
                                setTimeRoom({
                                    // start: parseInt(r.data[0].tsStart * 1000),
                                    // end: parseInt(r.data[0].tsEnd * 1000),
                                    start: moment.unix(r.data[0].tsStart).startOf('minute'),
                                    end: moment.unix(r.data[0].tsEnd).startOf('minute'),
                                }),
                            );
                            dispatch(setStartTimeSecond(convertUnixTimestampToSeconds(r.data[0].tsStart)));
                            dispatch(setEndTimeSecond(convertUnixTimestampToSeconds(r.data[0].tsEnd)));
                            setStartTimePicker({
                                startDate: moment.unix(r.data[0].tsStart).startOf('minute'),
                                endDate: null,
                            });
                            setEndTimePicker({
                                startDate: moment.unix(r.data[0].tsEnd).startOf('minute'),
                                endDate: null,
                            });
                            //setTimeRoom when copy room
                            setIsFetchedData(false);
                            isCopy && dispatch(setCurrentTime());
                            if (isCopy) {
                                if (timeMinute >= 15 && timeMinute < 120) {
                                    dispatch(setEndTimeSecond(dataPeriod?.startSecond + (timeMinute * 60)))
                                    if (dataPeriod?.end) {
                                        dispatch(
                                            setEndTime(
                                                moment(dataPeriod?.end)?.startOf('day').add(parseInt(dataPeriod?.startSecond + (timeMinute * 60)), 'seconds'),
                                            )
                                        );
                                    }
                                } else if (timeMinute < 15) {
                                    dispatch(setEndTimeSecond(dataPeriod?.startSecond + (15 * 60)))
                                    if (dataPeriod?.end) {
                                        dispatch(
                                            setEndTime(
                                                moment(dataPeriod?.end)?.startOf('day').add(parseInt(dataPeriod?.startSecond + (15 * 60)), 'seconds'),
                                            )
                                        );
                                    }
                                }
                            }
                            setIsFetchedData(true);
                        }
                    })
                    .catch((e) => {
                        let detail_error = e.response.data;
                        if (detail_error?.data === 'ROOM_NOT_EXISTED') {
                            toastError(t('toast.roomNotExist'));
                            navigate(`${PATH_ROOT}/manager-meeting`);
                        }
                    });
            }
        } else {
            setIsFetchedData(false)
            setIsCreate(true);
            dispatch(setCurrentTime());
            if (timeMinute >= 15 && timeMinute < 120) {
                dispatch(setEndTimeSecond(dataPeriod?.startSecond + (timeMinute * 60)))
                if (dataPeriod?.end) {
                    dispatch(
                        setEndTime(
                            moment(dataPeriod?.end)?.startOf('day').add(parseInt(dataPeriod?.startSecond + (timeMinute * 60)), 'seconds'),
                        )
                    );
                }
            } else if (timeMinute < 15) {
                dispatch(setEndTimeSecond(dataPeriod?.startSecond + (15 * 60)))
                if (dataPeriod?.end) {
                    dispatch(
                        setEndTime(
                            moment(dataPeriod?.end)?.startOf('day').add(parseInt(dataPeriod?.startSecond + (15 * 60)), 'seconds'),
                        )
                    );
                }
            }
            setTimeout(() => {
                setIsFetchedData(true);
            }, 100)

            getCurrentUserForSchedule()
                .then((currentUser) => {
                    if (!currentUser) {
                        return;
                    }

                    setData((prevData) => ({
                        ...prevData,
                        operatorList: [
                            {
                                ...currentUser,
                                role: ROLE.OWNER,
                            },
                        ],
                    }));
                })
                .catch((e) => { });
        }

        return () => {
            dispatch(setIsChangePeriod(null));
            dispatch(setClearValue());
            dispatch(setCurrentTime());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    /**
     * Kiểm tra giới hạn người được mời theo gói license
     */

    return (
        <ContainerPage>
            {/* Header */}
            <DialogWarningLicenseRoom />
            <BreadcrumbsCC>
                <Box>
                    {mdPixel
                        ? (<ButtonCancelIcon onClick={() => { handleCancelRoom() }} />)
                        : (<IconButton sx={{ border: `1px solid ${theme.palette.secondary.main}` }} onClick={() => { handleCancelRoom() }}>
                            <IconCancel type={theme.palette.secondary.main} /></IconButton>
                        )}
                    {mdPixel
                        ? (<ButtonSaveIcon isSubmit={isSubmit || isUpdating} onClick={() => { handleCreateRoom() }} />)
                        : (
                            <IconButton
                                sx={{ backgroundColor: `${color.RedP00} !important`, marginLeft: '10px' }}
                                onClick={() => {
                                    handleCreateRoom();
                                }}
                            >
                                <IconSave width={18} height={18} style={{ width: '14px', height: '14px' }} />
                            </IconButton>
                        )}
                </Box>
            </BreadcrumbsCC>
            <ModelPeriodDay
                open={openConfirm}
                handleClickOpen={handleOpenModal}
                handleClose={handleCloseModal}
                periodTime={periodTime}
                typePeriod={typePeriod}
            />
            {/* Body */}
            <InfoMeetingCC timeMinute={timeMinute} maxNumberPeople={maxNumberPeople} />
            <Box
                className={'info-meeting'}
                sx={{
                    padding: {
                        xs: `${theme.spacing(3)} 3% ${theme.spacing(1.75)} 3%`,
                        sm: `${theme.spacing(3)} 3% ${theme.spacing(1.75)} ${theme.spacing(5.25)}`,
                    },
                    boxShadow: '0px -1px 2px -1px #606060;',
                    overflow: 'scroll',
                    height: 'calc(100vh - 48px - 60px - 60px)'
                }}
            >
                <Grid container spacing={2} columnSpacing={3}>
                    <Grid className="item-schedule title-schedule" item xs={12} sm={3} lg={3} xl={1.5} sx={{ alignItems: 'start' }}>
                        {t('room.topic')}<span style={{ color: color.main }}>*</span>
                    </Grid>
                    <Grid
                        className="item-schedule content-schedule"
                        item
                        xs={12}
                        sm={9}
                        lg={9}
                        xl={10.5}
                        sx={{ paddingLeft: '50px' }}
                    >
                        <TextField
                            autoFocus
                            fullWidth
                            variant="outlined"
                            placeholder={t('room.desc.text2')}
                            disabled={dataPeriod.isChangePeriod === 1}
                            value={data?.roomName}
                            onChange={(e) => {
                                setData({ ...data, roomName: e.target.value });
                                if (!changeData) {
                                    setChangeData(true);
                                }
                            }}
                            error={clickSubmit && errorValid['roomName']?.value}
                            helperText={clickSubmit && t(errorValid['roomName']?.helperText)}
                            InputProps={
                                data.roomName === '' || dataPeriod.isChangePeriod === 1
                                    ? {}
                                    : {
                                        endAdornment: (
                                            <TooltipCC title={t('room.delete')}>
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={() =>
                                                        setData((prevData) => ({
                                                            ...prevData,
                                                            roomName: '',
                                                        }))
                                                    }
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <IconClose />
                                                </IconButton>
                                            </TooltipCC>
                                        ),
                                    }
                            }
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} columnSpacing={3} sx={{ paddingTop: `${theme.spacing(1.75)}` }}>
                    <Grid
                        className="item-schedule title-schedule"
                        sx={{ alignItems: 'start' }}
                        item
                        xs={12}
                        sm={3}
                        lg={3}
                        xl={1.5}
                    >
                        {t('room.description')}
                    </Grid>
                    <Grid className="item-schedule content-schedule" item xs={12} sm={9} lg={9} xl={10.5}>
                        <TextField
                            disabled={dataPeriod.isChangePeriod === 1}
                            multiline
                            rows={2.3}
                            fullWidth
                            variant="outlined"
                            sx={{ paddingLeft: '0px !important' }}
                            placeholder={t('room.desc.text3')}
                            value={data?.description}
                            onChange={(e) => {
                                setData({
                                    ...data,
                                    description: e.target.value,
                                });
                                if (!changeData) {
                                    setChangeData(true);
                                }
                            }}
                            error={clickSubmit && errorValid['description']?.value}
                            helperText={clickSubmit && t(errorValid['description']?.helperText)}
                            InputProps={
                                data.description === '' || dataPeriod.isChangePeriod === 1
                                    ? {}
                                    : {
                                        endAdornment: (
                                            <TooltipCC title={t('room.delete')}>
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={() =>
                                                        setData((prevData) => ({
                                                            ...prevData,
                                                            description: '',
                                                        }))
                                                    }
                                                    sx={{ p: 0.5 }}
                                                >
                                                    <IconClose />
                                                </IconButton>
                                            </TooltipCC>
                                        ),
                                    }
                            }
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} columnSpacing={3} sx={{ paddingTop: `${theme.spacing(1.75)}` }}>
                    <Grid className="item-schedule title-schedule" item xs={12} sm={3} md={3} lg={3} xl={1.5}>
                        <Box>
                            {t('attachFiles.title')}{' '}
                            <TooltipCC placement="top-start" title={t('room.settings.attachFile')}>
                                <InfoOutlinedIconCC />
                            </TooltipCC>
                        </Box>
                    </Grid>
                    <Grid
                        className="item-schedule content-schedule"
                        item
                        xs={12}
                        sm={9}
                        md={9}
                        lg={9}
                        xl={7}
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            maxHeight: '98px',
                            overflowY: 'auto',
                        }}
                    >
                        <Grid container spacing={2} columnSpacing={3}>
                            <Grid item xs={7} sm={6} md={3} lg={3} xl={2.9}>
                                <ButtonUploadFile isAttachment={true} handleUploadFile={handleUploadFile} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={0} sm={0} md={0} lg={0} xl={3.5} sx={{ display: { xs: 'none', xl: 'block' } }}>
                    </Grid>
                    {
                        files?.length > 0 &&
                        <Grid item xs={12} sm={3} md={3} lg={3} xl={1.5}>
                        </Grid>
                    }
                    {
                        files?.length > 0 &&
                        <Grid item xs={12} sm={9} md={9} lg={9} xl={10.5} sx={{ display: 'flex', flexWrap: 'wrap' }}>
                            {files?.length > 0 && files?.map((file, index) => (
                                <ItemFile key={index} isFirst={index === 0} file={file} onDeleteFile={onDeleteFile} />
                            ))}
                        </Grid>
                    }
                </Grid>
                <Grid container spacing={2} columnSpacing={3} sx={{ paddingTop: `${theme.spacing(1.75)}` }}>
                    <Grid
                        className="item-schedule title-schedule"
                        item
                        xs={12}
                        sm={3}
                        md={3}
                        lg={3}
                        xl={1.5}
                        sx={{ textWrap: { xl: 'nowrap', fontWeight: '550' } }}
                    >
                        {t('room.time-start')}<span style={{ color: color.main }}>*</span>
                    </Grid>
                    <Grid className="item-schedule content-schedule" item xs={12} sm={9} md={9} lg={9} xl={7}>
                        <Grid container spacing={2} columnSpacing={3} sx={{ display: 'flex', alignItems: 'center' }}>
                            <Grid item xs={7} sm={6} md={3} lg={3} xl={2.9}>
                                <Box>
                                    {((!isUpdate && isFetchedData) || (isUpdate && isFetchedData)) && (
                                        <DateRangePickerCC
                                            inputId="input-daterange-schedulemeeting-1"
                                            containerClass={clickSubmit && ((checkDurationMin && checkDurationMax) ? `daterange-container` : `daterange-container-error`)}
                                            timePicker={startTimePicker}
                                            setTimePicker={(object) => {
                                                setStartTimePicker(object);
                                                dispatch(
                                                    setStartTime(
                                                        moment(object.startDate).startOf('day').add(dataPeriod.startSecond, 'seconds'),
                                                    ),
                                                );
                                                if (
                                                    moment(dataPeriod.end)
                                                        .startOf('day')
                                                        .diff(moment(object.startDate).startOf('day'), 'days') < 0
                                                ) {
                                                    setIsFetchedData(false);
                                                    setEndTimePicker(object);
                                                    setIsFetchedData(true);
                                                    dispatch(
                                                        setEndTime(
                                                            moment(object.startDate).startOf('day').add(
                                                                dataPeriod.endSecond,
                                                                'seconds',
                                                            ),
                                                        ),
                                                    );
                                                    let duration = moment(object.startDate)
                                                        .add(dataPeriod.endSecond, 'seconds')
                                                        .diff(
                                                            moment(object.startDate).add(
                                                                dataPeriod.startSecond,
                                                                'seconds',
                                                            ),
                                                            'minutes',
                                                        );

                                                    if (duration > timeMinute) {
                                                        setCheckDurationMax(false);
                                                        setCheckDurationMin(true);
                                                    } else if (duration < 15) {
                                                        setCheckDurationMin(false);
                                                        setCheckDurationMax(true);
                                                    } else {
                                                        setCheckDurationMax(true);
                                                        setCheckDurationMin(true);
                                                    }
                                                } else {
                                                    let duration = moment(dataPeriod.end).diff(
                                                        moment(object.startDate).startOf('day').add(dataPeriod.startSecond, 'seconds'),
                                                        'minutes',
                                                    );

                                                    if (duration > timeMinute) {
                                                        setCheckDurationMax(false);
                                                        setCheckDurationMin(true);
                                                    } else if (duration < 15) {
                                                        setCheckDurationMin(false);
                                                        setCheckDurationMax(true);
                                                    } else {
                                                        setCheckDurationMax(true);
                                                        setCheckDurationMin(true);
                                                    }
                                                }
                                                if (!checkChangeTime) {
                                                    setCheckChangeTime(true);
                                                }
                                            }}
                                            initialSettingsProps={{
                                                minDate:
                                                    isUpdate && isFetchedData
                                                        ? moment(dataPeriod.start).diff(
                                                            moment().startOf('minute'),
                                                            'minutes',
                                                        ) < 0
                                                            ? moment(dataPeriod.start).toDate()
                                                            : moment().startOf('minute').toDate()
                                                        : moment().startOf('minute').toDate(),
                                                maxDate: moment(maxDateTime.dateMax).toDate(),
                                                singleDatePicker: true,
                                                showDropdowns: true,

                                            }}
                                        />
                                    )}
                                </Box>
                            </Grid>
                            <Grid item xs={3} sm={3} md={1.7} lg={1.6} xl={1.5}>
                                {
                                    isFetchedData &&
                                    <TimePickerCC
                                        id={'timepicker-start'}
                                        validTime={clickSubmit ? (checkValidStartTimeSecond && checkDurationMin && checkDurationMax) : true}
                                        value={convertSecondToHourAndMinute(dataPeriod.startSecond)}
                                        setValue={(_time) => {
                                            let time = convertHourAndMinToSecond(_time);
                                            dispatch(setStartTimeSecond(parseInt(time)));
                                            time &&
                                                dispatch(
                                                    setStartTime(
                                                        moment(dataPeriod.start).startOf('day').add(parseInt(time), 'seconds'),
                                                    ),
                                                );
                                            if (time || time === 0) {
                                                setCheckValidStartTimeSecond(true);
                                                let duration = moment(dataPeriod.end).diff(
                                                    moment(dataPeriod.start).startOf('day').add(parseInt(time), 'seconds'),
                                                    'minutes',
                                                );
                                                if (duration > timeMinute) {
                                                    setCheckDurationMax(false);
                                                    setCheckDurationMin(true);
                                                } else if (duration < 15) {
                                                    setCheckDurationMin(false);
                                                    setCheckDurationMax(true);
                                                } else {
                                                    setCheckDurationMax(true);
                                                    setCheckDurationMin(true);
                                                }
                                                if (!checkChangeTime) {
                                                    setCheckChangeTime(true);
                                                }
                                            } else {
                                                setCheckValidStartTimeSecond(false);
                                            }
                                        }}
                                    />
                                }
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={0.7}
                                lg={0.6}
                                xl={0.5}
                                sx={{ display: { md: 'flex' }, justifyContent: { md: 'center' } }}
                            >
                                <ArrowHorizontal />
                            </Grid>
                            <Grid item xs={7} sm={6} md={3} lg={3} xl={2.9}>
                                {((!isUpdate && isFetchedData) || (isUpdate && isFetchedData)) && (
                                    <DateRangePickerCC
                                        inputId="input-daterange-schedulemeeting-2"
                                        containerClass={clickSubmit && ((checkDurationMin && checkDurationMax) ? `daterange-container` : `daterange-container-error`)}
                                        timePicker={endTimePicker}
                                        setTimePicker={(object) => {
                                            setEndTimePicker(object);
                                            dispatch(
                                                setEndTime(
                                                    moment(object.startDate).startOf('day').add(dataPeriod.endSecond, 'seconds'),
                                                ),
                                            );
                                            let duration = moment(object.startDate).startOf('day')
                                                .add(dataPeriod.endSecond, 'seconds')
                                                .diff(moment(dataPeriod.start), 'minutes');

                                            if (duration > timeMinute) {
                                                setCheckDurationMax(false);
                                                setCheckDurationMin(true);
                                            } else if (duration < 15) {
                                                setCheckDurationMin(false);
                                                setCheckDurationMax(true);
                                            } else {
                                                setCheckDurationMax(true);
                                                setCheckDurationMin(true);
                                            }
                                            if (!checkChangeTime) {
                                                setCheckChangeTime(true);
                                            }
                                        }}
                                        initialSettingsProps={{
                                            minDate:
                                                isUpdate && isFetchedData
                                                    ? moment(dataPeriod.start).diff(
                                                        moment().startOf('minute'),
                                                        'minutes',
                                                    ) < 0
                                                        ? moment(dataPeriod.start).toDate()
                                                        : moment().startOf('minute').toDate()
                                                    : moment().startOf('minute').toDate(),
                                            maxDate: moment(maxDateTime.dateMax).toDate(),
                                            singleDatePicker: true,
                                            showDropdowns: true,
                                        }}
                                    />
                                )}
                            </Grid>
                            <Grid item xs={3} sm={3} md={1.7} lg={1.6} xl={1.5}>
                                {
                                    isFetchedData &&
                                    <TimePickerCC
                                        id={'timepicker-end'}
                                        validTime={clickSubmit ? (checkValidEndTimeSecond && checkDurationMin && checkDurationMax) : true}
                                        value={convertSecondToHourAndMinute(dataPeriod.endSecond)}
                                        setValue={(_time) => {
                                            let time = convertHourAndMinToSecond(_time);
                                            dispatch(setEndTimeSecond(parseInt(time)));
                                            time &&
                                                dispatch(
                                                    setEndTime(
                                                        moment(dataPeriod.end).startOf('day').add(parseInt(time), 'seconds'),
                                                    ),
                                                );
                                            if (time || time === 0) {
                                                setCheckValidEndTimeSecond(true);
                                                let duration = moment(dataPeriod.end)
                                                    .startOf('day')
                                                    .add(parseInt(time), 'seconds')
                                                    .diff(dataPeriod.start, 'minutes');
                                                if (duration > timeMinute) {
                                                    setCheckDurationMax(false);
                                                    setCheckDurationMin(true);
                                                } else if (duration < 15) {
                                                    setCheckDurationMin(false);
                                                    setCheckDurationMax(true);
                                                } else {
                                                    setCheckDurationMax(true);
                                                    setCheckDurationMin(true);
                                                }
                                                if (!checkChangeTime) {
                                                    setCheckChangeTime(true);
                                                }
                                            } else {
                                                setCheckValidEndTimeSecond(false);
                                            }
                                        }}
                                    />
                                }
                            </Grid>
                            <Grid
                                item
                                sx={{
                                    width: { sm: '100%', md: 'auto' },
                                    textWrap: 'nowrap',
                                }}
                            >
                                <Typography fontWeight={700}>{secondsToHoursMinutes(
                                    parseInt(moment(dataPeriod.end).unix()) - parseInt(moment(dataPeriod.start).unix()),
                                    t,
                                )}</Typography>
                            </Grid>
                            <Grid item xs={12} sx={{ display: 'flex', paddingTop: '0px !important' }}>
                                <FormHelperText
                                    style={{
                                        color: '#d32f2f',
                                    }}
                                >
                                    {clickSubmit && !checkDurationMin && t('meeting.min15m')}
                                </FormHelperText>
                                <FormHelperText
                                    style={{
                                        color: '#d32f2f',
                                    }}
                                >
                                    {clickSubmit && !checkDurationMax && <span>{t('meeting.maxTime')} {minuteToHourAndMinute(timeMinute, t)}</span>}
                                </FormHelperText>
                                <FormHelperText
                                    style={{
                                        color: '#d32f2f',
                                    }}
                                >
                                    {((!checkValidStartTimeSecond || !checkValidEndTimeSecond) && (checkDurationMin && checkDurationMax)) && t('meeting.validTime')}
                                </FormHelperText>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3} xl={0} sx={{ display: { xl: 'none' } }}></Grid>
                    <Grid className="item-schedule" item xs={12} sm={9} md={9} lg={9} xl={3.5}>
                        <Grid container spacing={0}>
                            <Grid
                                item
                                xs={6}
                                sm={4}
                                md={4}
                                xl={4}
                                sx={{ display: 'flex', alignItems: 'center' }}
                            >
                                <Checkbox
                                    disabled={dataPeriod.isChangePeriod === 1}
                                    size="small"
                                    checked={isPeriod}
                                    onChange={(e) => setIsPeriod(e.target.checked)}
                                />
                                <Box
                                    sx={{ marginLeft: '5px', fontWeight: '500', cursor: dataPeriod.isChangePeriod === 1 ? 'auto' : 'pointer' }}
                                    onClick={() => {
                                        if (dataPeriod.isChangePeriod !== 1) {
                                            if (isPeriod) {
                                                setIsPeriod(false)
                                            } else setIsPeriod(true)
                                        }
                                    }}
                                >
                                    <Typography fontWeight={500} color={theme => theme.palette.text[700]}>{t('room.calendar')}</Typography>
                                </Box>
                            </Grid>
                            <Grid
                                item
                                xs={6}
                                sm={8}
                                md={8}
                                xl={8}
                                sx={{ display: isPeriod ? 'flex' : 'none', alignItems: 'center' }}
                            >
                                <Box display={'flex'}>
                                    <Typography fontWeight={600} color={theme => theme.palette.text[700]}>{t('room.again')}</Typography>
                                    <span style={{ color: color.main }}>*</span>
                                </Box>
                                <FormControl size="small" sx={{ marginLeft: '8px', width: 'calc(100% - 71px)' }}>
                                    <Select
                                        name="period"
                                        id="period"
                                        error={clickSubmit && isPeriod && dataPeriod.time_profile_type_id === null}
                                        displayEmpty
                                        value={dataPeriod.time_profile_type_id}
                                        renderValue={(value) => {
                                            if (dataPeriod.start_time === null || !value) {
                                                return (
                                                    <Typography
                                                        sx={{
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            color: theme => theme.palette.text.secondary
                                                        }}
                                                    >
                                                        {t('room.desc.text1')}
                                                    </Typography>
                                                );
                                            }
                                            if (
                                                dataPeriod.time_profile_type_id !== null &&
                                                dataPeriod.start_time !== null
                                            ) {
                                                return (
                                                    <TooltipCC
                                                        title={CreateDescPeriod(dataPeriod, t)}
                                                        style={{
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                        }}
                                                    >
                                                        <div>{CreateDescPeriod(dataPeriod, t)}</div>
                                                    </TooltipCC>
                                                );
                                            }
                                        }}
                                        disabled={dataPeriod.isChangePeriod === 1}
                                        onChange={(event) => setTypePeriod(event.target.value)}
                                        size="small"
                                        fullWidth
                                    >
                                        <MenuItem value={1} onClick={() => handleOpenModalPeriod(1)}>
                                            {t('room.by-day')}
                                        </MenuItem>
                                        <MenuItem value={2} onClick={() => handleOpenModalPeriod(2)}>
                                            {t('room.by-week')}
                                        </MenuItem>
                                        <MenuItem value={3} onClick={() => handleOpenModalPeriod(3)}>
                                            {t('room.by-month')}
                                        </MenuItem>
                                    </Select>
                                    <FormHelperText style={{ color: color.error, position: 'absolute', top: '35px', fontSize: '14px' }}>
                                        {clickSubmit && isPeriod && dataPeriod.time_profile_type_id === null
                                            ? t('room.helper-text-period')
                                            : ''}
                                    </FormHelperText>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container spacing={2} columnSpacing={3} sx={{ paddingTop: `${theme.spacing(3.5)}` }}>
                    <Grid className="item-schedule title-schedule" item xs={12} sm={3} lg={3} xl={1.5} sx={{ alignItems: 'center' }}>
                       {t('room.security')}
                    </Grid>
                    <Grid className="item-schedule content-schedule" item xs={12} sm={9} lg={9} xl={10.5}>
                        <Grid container spacing={2}>
                            <Grid
                                className="item-schedule title-schedule"
                                item
                                xs={6}
                                sm={12}
                                lg={6}
                                xl={4}
                                sx={{ display: 'flex', alignItems: 'center' }}
                            >
                                <Grid container spacing={2}>
                                    <Grid
                                        item
                                        xs={6}
                                        sm={4}
                                        md={4}
                                        xl={3}
                                        sx={{ display: 'flex', alignItems: 'start' }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Checkbox
                                                sx={{ marginLeft: { xl: '-8px' } }}
                                                size="small"
                                                checked={isPassword}
                                                disabled={dataPeriod.isChangePeriod === 1}
                                                onChange={(e) => {
                                                    setisPassword(e.target.checked);
                                                    if (e.target.checked && data.password.length === 0) {
                                                        setData({
                                                            ...data,
                                                            password: createRandomPassword(),
                                                        });
                                                    }
                                                }}
                                            />
                                            <Box
                                                sx={{ marginLeft: '5px', cursor: dataPeriod.isChangePeriod === 1 ? 'auto' : 'pointer' }}
                                                onClick={() => {
                                                    if (dataPeriod.isChangePeriod !== 1) {
                                                        if (isPassword) {
                                                            setisPassword(false)
                                                        } else {
                                                            setisPassword(true)
                                                            if (data.password.length === 0) {
                                                                setData({
                                                                    ...data,
                                                                    password: createRandomPassword(),
                                                                });
                                                            }
                                                        }
                                                    }
                                                }}
                                            >
                                                <Typography fontWeight={'500'} color={theme => theme.palette.text[700]}>{t('room.password')}</Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                    {isPassword ? (
                                        <Grid className="item-schedule xl-pt-12px" item xs={6} sm={8} md={8} xl={9}>
                                            <CssTextField
                                                disabled={dataPeriod.isChangePeriod === 1}
                                                value={data.password}
                                                error={clickSubmit && errorValid['password']?.value}
                                                helperText={clickSubmit && t(errorValid['password']?.helperText)}
                                                onChange={(e) => setData({ ...data, password: e.target.value })}
                                                sx={{ paddingRight: '0px !important' }}
                                                InputProps={{
                                                    endAdornment: dataPeriod.isChangePeriod !== 1 && (
                                                        <InputAdornment position="end">
                                                            {data.password !== '' ? (
                                                                <IconButton
                                                                    tabIndex={-1}
                                                                    onClick={() => setData({ ...data, password: undefined })}
                                                                    sx={{ p: 0.5 }}
                                                                >
                                                                    <IconClose />
                                                                </IconButton>
                                                            ) : (
                                                                <></>
                                                            )}
                                                            <IconButton
                                                                tabIndex={-1}
                                                                onClick={() => {
                                                                    let newPass = createRandomPassword();
                                                                    setData({ ...data, password: newPass });
                                                                }}
                                                                sx={{ p: 0.5, mr: '20px' }}
                                                            >
                                                                <ReloadIcon />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                    ) : (
                                        <></>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid
                                className="item-schedule "
                                item
                                xs={12}
                                sm={12}
                                lg={6}
                                xl={6}
                                sx={{ display: 'flex', alignItems: 'center' }}
                            >
                                <Checkbox
                                    disabled={dataPeriod.isChangePeriod === 1}
                                    size="small"
                                    checked={isLobby}
                                    onChange={(e) => setIsLobby(!isLobby)}
                                />
                                <Box
                                    sx={{ marginLeft: '5px', cursor: dataPeriod.isChangePeriod === 1 ? 'auto' : 'pointer' }}
                                    onClick={() => {
                                        if (dataPeriod.isChangePeriod !== 1) {
                                            if (isLobby) {
                                                setIsLobby(false)
                                            } else setIsLobby(true)
                                        }
                                    }}
                                >
                                    <Typography fontWeight={500} color={theme => theme.palette.text[700]}>{t('room.waiting-room')}</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container spacing={2} columnSpacing={3} sx={{ paddingTop: `${theme.spacing(1.75)}` }}>
                    <Grid
                        className="item-schedule title-schedule"
                        item
                        xs={12}
                        sm={3}
                        lg={3}
                        xl={1.5}
                        sx={{ textWrap: { xl: 'nowrap' }, alignItems: 'center' }}
                    >
                        <Box>
                            {t('room.settings.meeting-mode-title')}{' '}
                            <TooltipCC placement="top-start" title={t('room.settings.content-meeting')}>
                                <InfoOutlinedIconCC />
                            </TooltipCC>
                        </Box>
                    </Grid>
                    <Grid className="item-schedule content-schedule" item xs={12} sm={9} lg={9} xl={10.5}>
                        <MeetingMode data={data} setData={setData} dataPeriod={dataPeriod} />
                    </Grid>
                </Grid>
                <Grid container spacing={2} columnSpacing={3} sx={{ paddingTop: `${theme.spacing(1.75)}` }}>
                    <Grid
                        className="item-schedule title-schedule"
                        item
                        xs={12}
                        sm={3}
                        lg={3}
                        xl={1.5}
                        sx={{ textWrap: { xl: 'nowrap' } }}
                    >
                        {t('room.settings.oper-list')}
                    </Grid>
                    <Grid className="item-schedule content-schedule" item xs={12} sm={9} lg={9} xl={10.5}>
                        <Box sx={{ minHeight: '52px', display: 'flex', alignItems: 'center' }}>
                            <ListParticipantsShareRoom
                                userListRender={data.operatorList}
                                setChangeDataParticipant={handleChangeDataShareOperators}
                                style={{
                                    borderRadius: '6px',
                                    border: '1px solid #AAAAAA',
                                    height: '100%',
                                    padding: '5.75px 10px 5.75px 0',
                                    cursor: (data.operatorList.length === 0 && dataPeriod.isChangePeriod !== 1)
                                        ? 'pointer'
                                        : 'auto',
                                }}
                                t={t}
                                addPeople={true}
                                handleOpenModalShareSubtitles={handleOpenModalShareSubtitlesForOperator}
                                isChangePeriod={dataPeriod.isChangePeriod === 1}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <Grid container spacing={2} columnSpacing={3} sx={{ paddingTop: `${theme.spacing(1.75)}` }}>
                    <Grid
                        className="item-schedule title-schedule"
                        item
                        xs={12}
                        sm={3}
                        lg={3}
                        xl={1.5}
                        sx={{ textWrap: { xl: 'nowrap' } }}
                    >
                        {t('room.settings.par-list')}
                    </Grid>
                    <Grid className="item-schedule content-schedule" item xs={12} sm={9} lg={9} xl={10.5}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {/* <ListUser dataParticipants={dataParticipant} setChangeDataParticipant={handleChangeDataParticipant}/> */}
                            <ListParticipantsShareRoom
                                userListRender={data.participantList}
                                setChangeDataParticipant={handleChangeDataShareParticipant}
                                style={{
                                    borderRadius: '6px',
                                    border: '1px solid #AAAAAA',
                                    height: '100%',
                                    padding: '5.75px 10px 5.75px 0',
                                    cursor: (data.participantList.length === 0 && dataPeriod.isChangePeriod !== 1) ? 'pointer' : 'auto',
                                }}
                                t={t}
                                addPeople={true}
                                handleOpenModalShareSubtitles={handleOpenModalShareSubtitles}
                                isChangePeriod={dataPeriod.isChangePeriod === 1}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <Grid container spacing={2} columnSpacing={3} sx={{ paddingTop: `${theme.spacing(1.75)}` }}>
                    <Grid
                        className="item-schedule title-schedule"
                        item
                        xs={12}
                        sm={3}
                        lg={3}
                        xl={1.5}
                        sx={{ textWrap: { xl: 'nowrap' }, alignItems: 'start' }}
                    >
                        {t('room.settings.title')}
                    </Grid>
                    <Grid
                        className="item-schedule content-schedule"
                        item
                        xs={12}
                        sm={9}
                        lg={9}
                        xl={10.5}
                        sx={{ marginLeft: { xl: '-10px' } }}
                    >
                        <AdvancedSettings data={data} setData={setData} />
                    </Grid>
                </Grid>
            </Box>
        </ContainerPage>
    );
};

export default ScheduleMeeting;
